/**
 * Sessie 70 punt 4: op de iPhone staat de voet van het antwoordvak (met
 * de oranje hoofdknop) vast onderaan het midden, niet onderaan een lange
 * pagina. Een afrondvoorstel ("voorstel: afronden, bedankje" met
 * Afronden) staat er direct boven, zodat afronden zonder antwoord in één
 * tik kan. Laptop houdt de ene pagina die doorscrolt tot en met het vak.
 *
 * Het midden maakt de plek; de voet en de conceptregel zetten zich daar
 * met een portal neer als de plek er is.
 */
import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

const SMAL = "(max-width: 900px)";

function isSmal(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(SMAL).matches
    : false;
}

/** Staat het scherm in de iPhone-indeling? Volgt draaien en slepen. */
export function useSmal(): boolean {
  const [smal, setSmal] = useState(isSmal);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const lijst = window.matchMedia(SMAL);
    const bij = () => setSmal(lijst.matches);
    lijst.addEventListener?.("change", bij);
    return () => lijst.removeEventListener?.("change", bij);
  }, []);
  return smal;
}

export interface VoetPlek {
  regel: HTMLElement | null;
  voet: HTMLElement | null;
  /** Motor 7 (keuze 10 van 75): op de laptop de balk onder het midden, zoals de
   *  mock; op de iPhone leeg, dan staat de balk in de vaste voet. */
  balk?: HTMLElement | null;
}

const VoetPlekContext = createContext<VoetPlek | null>(null);

export const VoetPlekProvider = VoetPlekContext.Provider;

/** Zet de inhoud op de vaste plek als die er is (iPhone), anders ter plekke. */
export function OpVastePlek({
  plek,
  children,
}: {
  plek: "regel" | "voet" | "balk";
  children: ReactNode;
}) {
  const plekken = useContext(VoetPlekContext);
  const doel = plekken?.[plek] ?? null;
  return doel ? createPortal(children, doel) : <>{children}</>;
}
